"use client";

import { useEffect, useState } from "react";
import { CheckCircle2, XCircle, X } from "lucide-react";
import { notifyStore, type NotificationItem } from "@/lib/notify";

export function NotificationToaster() {
  const [items, setItems] = useState<NotificationItem[]>([]);

  useEffect(() => {
    notifyStore.subscribe(setItems);
    return () => notifyStore.unsubscribe(setItems);
  }, []);

  if (items.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-[100] flex flex-col gap-2 w-[320px] pointer-events-none">
      {items.map((item) => (
        <div
          key={item.id}
          className={`notification-enter pointer-events-auto flex items-start gap-3 px-4 py-3.5 bg-white border rounded-lg shadow-lg ${
            item.type === "success"
              ? "border-green-200 shadow-green-900/5"
              : "border-red-200 shadow-red-900/5"
          }`}
        >
          {item.type === "success" ? (
            <CheckCircle2 className="w-[18px] h-[18px] text-green-500 flex-shrink-0 mt-0.5" />
          ) : (
            <XCircle className="w-[18px] h-[18px] text-red-500 flex-shrink-0 mt-0.5" />
          )}
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-slate-900 leading-snug">{item.title}</p>
            {item.description && (
              <p className="text-xs text-slate-500 mt-0.5 leading-snug">{item.description}</p>
            )}
            {item.actions && item.actions.length > 0 && (
              <div className="flex items-center gap-3 mt-1.5">
                {item.actions.map((a) => (
                  <button
                    key={a.label} type="button"
                    onClick={() => { notifyStore.dismiss(item.id); a.onClick(); }}
                    className="text-xs font-semibold text-blue-600 hover:text-blue-700"
                  >
                    {a.label}
                  </button>
                ))}
              </div>
            )}
          </div>
          <button
            onClick={() => notifyStore.dismiss(item.id)}
            className="flex-shrink-0 text-slate-300 hover:text-slate-500 transition-colors mt-0.5"
            aria-label="Đóng thông báo"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      ))}
    </div>
  );
}
